import styled from 'styled-components';
import spacing from '../../../helpers/spacing';
import { CardGrid } from '../../CardGrid';

export const StyledGrid = styled(CardGrid)`
  && {
    margin-bottom: ${spacing(-4)};
  }
`;
